import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGetAllOrderedProduct } from "../../../../services/Production/BomService";

export const getAllProduct = createAsyncThunk(
  "bom/form/data/getProducts",
  async () => {
    const response = await apiGetAllOrderedProduct();
    return response;
  }
);
export const getEmployeeId = createAsyncThunk();
//   "employee/data/getEmployeeId",
//   async (data) => {
//     const response = await apiGetAllEmployeeId(data);
//     return response.data;
//   }

export const initialTableData = {
  total: 0,
  pageIndex: 1,
  pageSize: 10,
  query: "",
  sort: {
    order: "",
    key: "",
  },
};

export const initialFilterData = {
  name: "",
  category: ["bags", "cloths", "devices", "shoes", "watches"],
  status: [0, 1, 2],
  productStatus: 0,
};

const dataSlice = createSlice({
  name: "new/bom/data",
  initialState: {
    loading: false,
    products: [],
    tableData: initialTableData,
    filterData: initialFilterData,
  },
  reducers: {
    updateProductList: (state, action) => {
      state.employeeList = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setFilterData: (state, action) => {
      state.filterData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProduct.fulfilled, (state, action) => {
        state.products = action.payload.data.data || [];
      })
      .addCase(getEmployeeId.pending, (state, action) => {
        state.loading = true;
      });
  },
});

export const { updateProductList, setTableData, setFilterData } =
  dataSlice.actions;

export default dataSlice.reducer;
